module.exports = __webpack_public_path__ + "static/img/IMG_3395.9ceccc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_3395.jpg
// module id = 282
// module chunks = 0